import { PATH } from '../../constants/router'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { InfoCircleOutlined } from '@ant-design/icons'
import BaseButton from '../../components/BasicComponent/BaseButton'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import AutomatedTrafficFineNotificationServiceCard from '../../components/FeaturesComponent/automatedTrafficFineNotificationServiceCard'
import AutomatedTrafficFineNotificationStep from '../../components/FeaturesComponent/automatedTrafficFineNotificationStep'
import HeaderPartner from '../../components/FeaturesComponent/headerPartner'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import useAutomatedTrafficFineNotificationServices, {
  SERVICE_TYPE_EMAIL,
  SERVICE_TYPE_SMS,
  SERVICE_TYPE_ZALO
} from '../../hooks/useAutomatedTrafficFineNotificationServices'
import { validatePhoneNumber } from '../../helper/common'
import { Modal } from 'antd'
import './index.scss'
import { IS_TAX_CDS_MODE, CURRENT_APP_MODE_CONFIG } from '../../constants/appMode'

export default function AutomatedTrafficFineNotificationServices() {
  const history = useHistory()

  const {
    onSelectService,
    servicesByCategory,
    selectedServices,
    isChoosed,
    selectedEmailService,
    isEmailValid,
    email,
    handleChangeEmailInput,
    errorEmail,
    selectedServiceEmailToCheck,
    handleCancelEmailModal,
    handleAgreeEmailModal,
    taxCdsFreelanceServices,
    taxCdsSmeServices,
    taxCdsOfficeServices
  } = useAutomatedTrafficFineNotificationServices()

  // Get phoneNumber from sessionStorage if already saved
  const savedPhoneNumber = typeof window !== 'undefined' ? sessionStorage.getItem('phoneNumber') || '' : ''
  const phoneChecked = typeof window !== 'undefined' ? sessionStorage.getItem('phoneChecked') === 'true' : false

  // Show phone input if not checked from param
  const showPhoneInput = CURRENT_APP_MODE_CONFIG.showPhoneInput && !phoneChecked

  // State for phone input
  const savedPhoneValidation = validatePhoneNumber(savedPhoneNumber)

  const [phoneNumber, setPhoneNumber] = useState(savedPhoneNumber)
  const [phoneError, setPhoneError] = useState('')
  const [isPhoneValid, setIsPhoneValid] = useState(!showPhoneInput || savedPhoneValidation.isValid)
  const zaloServices = servicesByCategory[SERVICE_TYPE_ZALO]
  const smsServices = servicesByCategory[SERVICE_TYPE_SMS]
  const emailServices = servicesByCategory[SERVICE_TYPE_EMAIL]
  const carServices = servicesByCategory['OTO']
  const motorbikeServices = servicesByCategory['XEMAY']

  // Handle phone input change
  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, '')
    setPhoneNumber(value)

    const validation = validatePhoneNumber(value)
    setIsPhoneValid(validation.isValid)
    setPhoneError(validation.errorMessage)
  }

  const handleNextStep = () => {
    const selectedService = selectedServices[0]
    const vehicleType = selectedService?.vehicleType || undefined

    if (showPhoneInput) {
      const validation = validatePhoneNumber(phoneNumber)

      if (!validation.isValid) {
        setIsPhoneValid(false)
        setPhoneError(validation.errorMessage)
        return
      }

      sessionStorage.setItem('phoneNumber', phoneNumber)
      sessionStorage.setItem('phoneChecked', 'true')
    }

    if (IS_TAX_CDS_MODE) {
      history.push(PATH.TAX_CDS_SMART_ASSISTANT_INFO, {
        services: selectedServices
      })
      return
    }

    history.push(`${PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_VEHICLES}`, {
      services: selectedServices,
      vehicleType,
      email
    })
  }
  return (
    <LayoutPartner>
      <HeaderPartner title={CURRENT_APP_MODE_CONFIG.servicePageTitle} />
      <div className="AutomatedTrafficFineNotificationServices">
        <AutomatedTrafficFineNotificationStep step={0} />
        <div className="AutomatedTrafficFineNotificationServices-purpose">
          {CURRENT_APP_MODE_CONFIG.servicePurposeText}
        </div>
        {/* Phần nhập số điện thoại - chỉ hiển thị khi chưa có số điện thoại từ trang introduce */}
        {/* Có thể sửa / nhập lại số điện thoại nếu không lấy được số điện thoại từ url trong trang introduce */}
        {showPhoneInput && (
          <div className="vehicle-info phone-input-section">
            <div className="vehicle-info__title">Nhập số điện thoại (Bắt buộc)</div>
            <div className={`vehicle-info__input-wrapper ${phoneError ? 'vehicle-info__input-wrapper--has-error' : ''}`}>
              <input
                className={`vehicle-info__input ${phoneError ? 'vehicle-info__input--error' : ''}`}
                type="tel"
                value={phoneNumber}
                onChange={handlePhoneChange}
                placeholder="Nhập số điện thoại"
                inputMode="numeric"
                maxLength="10"
              />
              {phoneError && (
                <span className="vehicle-info__error">
                  <InfoCircleOutlined style={{ fontSize: '13px', marginRight: '4px' }} />
                  {phoneError}
                </span>
              )}
            </div>
          </div>
        )}

        <div className="service-cards-wrapper">
          {IS_TAX_CDS_MODE ? (
            <>
              <AutomatedTrafficFineNotificationServiceCard
                title="Lao động tự do"
                list={taxCdsFreelanceServices}
                onSelectService={onSelectService}
              />
              <AutomatedTrafficFineNotificationServiceCard
                title="SME / Hộ kinh doanh"
                list={taxCdsSmeServices}
                onSelectService={onSelectService}
              />
              <AutomatedTrafficFineNotificationServiceCard
                title="Nhân viên văn phòng"
                list={taxCdsOfficeServices}
                onSelectService={onSelectService}
              />
            </>
          ) : (
            <>
              <AutomatedTrafficFineNotificationServiceCard title="Tin nhắn Zalo" list={zaloServices} onSelectService={onSelectService} />
              <AutomatedTrafficFineNotificationServiceCard title="Tin nhắn SMS" list={smsServices} onSelectService={onSelectService} />
              <AutomatedTrafficFineNotificationServiceCard title="Tin nhắn Email" list={emailServices} onSelectService={onSelectService} />
              <AutomatedTrafficFineNotificationServiceCard title="Ô tô" list={carServices} onSelectService={onSelectService} />
              <AutomatedTrafficFineNotificationServiceCard title="Xe máy" list={motorbikeServices} onSelectService={onSelectService} />
            </>
          )}
        </div>
        <FixedBottom elementPaddingBottom={'LayoutPartner'}>
          <BaseButton
            onClick={handleNextStep}
            disabled={!isChoosed || (showPhoneInput && !isPhoneValid) || (!IS_TAX_CDS_MODE && selectedEmailService && !isEmailValid)}>
            Tiếp theo
          </BaseButton>
        </FixedBottom>
      </div>
      {CURRENT_APP_MODE_CONFIG.showEmailModal && (
  <Modal
        cancelText="Đóng"
        okText="Tiếp theo"
        onCancel={handleCancelEmailModal}
        onOk={handleAgreeEmailModal}
        title="Nhập email nhận thông báo"
        open={selectedServiceEmailToCheck}
        closable={false}
        okButtonProps={{
          style: {
            background: 'var(--brand-primary)!important',
            borderColor: 'var(--brand-primary)'
          }
        }}>
        <div className={`my-4 vehicle-info__input-wrapper ${errorEmail ? 'vehicle-info__input-wrapper--has-error' : ''}`}>
          <input
            className={`vehicle-info__input ${errorEmail ? 'vehicle-info__input--error' : ''}`}
            value={email}
            onChange={handleChangeEmailInput}
            placeholder="info@gmail.com"
          />
          {errorEmail && (
            <span className="vehicle-info__error">
              <InfoCircleOutlined style={{ fontSize: '13px', marginRight: '4px' }} />
              {errorEmail}
            </span>
          )}
        </div>
      </Modal>
      )}
    </LayoutPartner>
  )
}
